import { render, staticRenderFns } from "./ReferencePost.vue?vue&type=template&id=b67e6d56&scoped=true&"
import script from "./ReferencePost.vue?vue&type=script&lang=js&"
export * from "./ReferencePost.vue?vue&type=script&lang=js&"
import style0 from "./ReferencePost.vue?vue&type=style&index=0&id=b67e6d56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67e6d56",
  null
  
)

export default component.exports